import Vue from 'vue'

const state = {
}

const getters = {
    level2variant(state) {
        return (status) => {
            const table = {
                '000': 'dark',
                '001': 'success',
                '100': 'info',
                '101': 'secondary',
                '200': 'warning',
                '300': 'danger',
            }
            return table[status]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/users' + (data.uuid ? '/' + data.uuid : ''), data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async destroy (context, data) {
        const response = await axios.delete('/api/v1/users/' + data.uuid)
            .catch(error => error.response || null)
        return response
    },
    async index (context, data) {
        let config = {
            params: (typeof data === 'object' ? data : null)
        }
        if (typeof data === 'object' && data.download) {
            config.responseType = 'blob'
            config.dataType = 'binary'
            config.headers = { 'Cache-Control': 'no-cache' }
        }
        return axios
            .get('/api/v1/users' + (typeof data  === 'string' ? '/' + data : ''), config)
            .then(async (response) => {
                if (typeof data === 'object' && data.download) {
                    Vue.prototype.download(response)
                }
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async download (context, data) {
        data = Object.assign(data, { download: true, })
        const response = await axios.get('/api/v1/users', {
            params: (typeof data === 'object' ? data : null),
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        Vue.prototype.download(response)
        return response
    },
    async show (context, id) {
        const response = await axios.get('/api/v1/u/' + id)
            .catch(error => error.response || null)
        return response
    },
    async approve (context, data) {
        return axios.post('/api/v1/users/' + data.uuid + '/approve', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async like (context, data) {
        const response = await axios.put('/api/v1/users/' + data.id + '/like/' + (data.like ? 1 : 0))
            .catch(error => error.response || null)
        return response
    },
    async contact (context, data) {
        const response = await axios.post('/api/v1/users/' + data.id + '/contact', data)
            .catch(error => error.response || null)

        ga('send', {
            hitType: 'event',
            eventCategory: 'item',
            eventAction: 'contact',
            eventLabel: data.id,
        })
        return response
    },
    async status (context, data) {
        const response = await axios.put('/api/v1/users/' + data.id + '/status', data)
            .catch(error => error.response || null)
        return response
    },
    //  async logout (context, data) {
    //    const response = await axios.get('/api/v1/auth/logout', data).catch(error => error.response || null)
    //    context.commit('setUser', null)
    //    return response
    //  },
    //  async signup (context, data) {
    //    const response = await axios.post('/api/v1/auth/signup', data).catch(error => error.response || null)
    //    context.commit('setUser', response.data)
    //    return response
    //  },
    //  async me (context) {
    //    const response = await axios.get('/api/v1/auth/me').catch(error => error.response || null)
    //    context.commit('setUser', response.data)
    //    return response
    //  }
    async syncCustomers (context, page_id) {
        const response = await axios.get('/api/v1/users/' + page_id + '/sync-customers', {
        })
            .catch(error => error.response || null)
//        this._vm.$set(context.state.user, 'users', response.data || []);
        return response
    },
    async fetch_orders (context, data) {
        const response = await axios.get('/api/v1/users/' + data.id + '/fetch_orders', {
            params: (typeof data === 'object' ? data : null),
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        return response
    },
    async download_orders (context, data) {
        data = Object.assign(data, { download: true, })
        const response = await axios.get('/api/v1/users/' + data.id + '/fetch_orders', {
            params: (typeof data === 'object' ? data : null),
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        Vue.prototype.download(response)
        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


